import { Button, Divider, FormControl, Grid, IconButton, InputAdornment, OutlinedInput, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { showNotification } from '../common/Notification/ToastifyNotification';
import { postDataRequest } from '../common/commonfunction';
import { baseURL } from '../common/const';
import { resetPassword } from '../common/api';
import { LoadingPage } from '../common/LoadingPage';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const NewGrid = styled(Grid)(({ theme }) => ({
    marginTop: 1,
    width: '50%',
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
        width: '100%',
        margin: 0
    },
}));

const Typo = styled(Typography)(({ theme }) => ({
    color: 'black',
    fontSize: 14,
    fontWeight: 600,
}));

const ResetPassword = () => {
    const navigate = useNavigate();
    const { search } = window?.location;
    const id = search.split('=')?.[1]?.split('&')?.[0];
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [dataLoading, setDataLoading] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [confirmShowPassword, setConfirmShowPassword] = React.useState(false);

    return (
        <section>
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <div>
                <h2>Reset Password</h2>
            </div>
            <Divider />
            <NewGrid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                    <FormControl size="small" fullWidth variant="standard">
                        <Typo variant='body1'>Password <span style={{ color: 'red' }}>*</span></Typo>
                        <OutlinedInput
                            id="standard-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            autoComplete="new-password"
                            onChange={(e) => {
                                setPassword(e.target.value);
                                const newErrors = errors;
                                if (!e.target.value) {
                                    newErrors.password = 'Password is required';
                                } else {
                                    newErrors.password = '';
                                }
                                setErrors(newErrors);
                            }}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={
                                            showPassword ? 'hide the password' : 'display the password'
                                        }
                                        onClick={() => setShowPassword((show) => !show)}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.password}</Typography>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <FormControl size="small" fullWidth variant="standard">
                        <Typo variant='body1'>Confirm Password <span style={{ color: 'red' }}>*</span></Typo>
                        <OutlinedInput
                            id="standard-adornment-password"
                            type={confirmShowPassword ? 'text' : 'password'}
                            autoComplete="new-password"
                            onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                const newErrors = errors;
                                if (!e.target.value) {
                                    newErrors.confirmPassword = 'Confirm is required';
                                } else if (password !== e.target.value) {
                                    newErrors.confirmPassword = 'Password and confirm Password is mismatch';
                                } else {
                                    newErrors.confirmPassword = '';
                                }
                                setErrors(newErrors);
                            }}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={
                                            confirmShowPassword ? 'hide the password' : 'display the password'
                                        }
                                        onClick={() => setConfirmShowPassword((show) => !show)}
                                        edge="end"
                                    >
                                        {confirmShowPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.confirmPassword}</Typography>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <Button
                        size="Medium"
                        variant="contained"
                        style={{ float: 'right', backgroundColor: '#003262' }}
                        onClick={async () => {
                            const newErrors = {};
                            if (!password) {
                                newErrors.password = 'Password is required';
                            }
                            if (!confirmPassword) {
                                newErrors.confirmPassword = 'Confirm Password is required';
                            }
                            setErrors(newErrors);
                            if (Object.keys(newErrors).length === 0) {
                                setDataLoading(true);
                                await postDataRequest(`${baseURL}/user/reset-password/${id}`, {
                                    query: resetPassword,
                                    variables: {
                                        userid: id,
                                        password
                                    },
                                }).then((resp) => {
                                    if (resp?.errors && resp?.errors[0]?.message) {
                                        showNotification(resp?.errors[0]?.message, 'error');
                                    } else {
                                        if (resp?.data.resetPassword) {
                                            showNotification('Password reset successfully', 'success');
                                            navigate(`/login`);
                                        }
                                    }
                                    setDataLoading(false);
                                }).catch((err) => {
                                    showNotification(err?.response?.data?.message, 'error');
                                    setDataLoading(false);
                                });
                            }
                        }}
                    >
                        Save
                    </Button>
                </Grid>
            </NewGrid>
        </section>
    );
};

export default ResetPassword;
